module.exports = __webpack_public_path__ + "img/Privinvest_homepage_crop-1800x900.da4e6cf6.jpg";